import { Box, Typography } from "@mui/material";
import {
  HtmlTooltip,
  RxChangePrescribedCard,
  RxChangeRequestedCard,
} from "../../Theme";
import { prescriptionForms } from "../../constants/RxChangeAlerts/rxChangeAlerts";
import RxPrescribedIcon from "../../images/icons/rx_precribed.svg";
import RxRequestedPharmaNote from "../../images/icons/pharamcy_note_icon.svg";
import RxRequestedIcon from "../../images/icons/rx_requested.svg";
import RxAlertsArrow from "../../images/icons/rxchange_alerts_right_arrow.svg";
import { ExpandableText } from "../../common/ExpandableText";
import { drugTypes } from "../../constants/common/DrugTypes";

const MedPrescribeRequested = ({
  prescribedData,
  requestedData,
  handleShowMedRequestPopupClick,
  rxChangeAlertsRequestData,
}: {
  prescribedData: any;
  requestedData: any;
  handleShowMedRequestPopupClick: any;
  rxChangeAlertsRequestData: any;
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "stretch",
          marginBottom: 2,
          width: "100%",
        }}
      >
        <RxChangePrescribedCard>
          <Box className="title">
            <img
              src={RxPrescribedIcon}
              alt="RX Change Request"
              loading="lazy"
              width="42px"
              height="42px"
            />
            <Typography variant="h6" fontSize={17} color="#0C585B">
              Rx Originally Prescribed
            </Typography>
            <Typography variant="caption" fontSize={14} color="#00000066">
              For Prescriber View
            </Typography>
          </Box>
          <Box className="content">
            <Typography component={"span"} variant={"body2"}>
              <strong>Written Date: </strong>
              <span className="content-text">
                {" "}
                {prescribedData?.rxWrittenDate
                  ? prescribedData?.rxWrittenDate
                  : "N/A"}
              </span>
            </Typography>
            <Typography component={"span"} variant={"body2"}>
              <strong>Drug Name:</strong>
              <span className="content-text">
                {" "}
                {prescribedData?.drugDescription
                  ? prescribedData?.drugDescription
                  : "N/A"}
              </span>
            </Typography>
            <Typography component={"span"} variant={"body2"}>
              <strong>SIG:</strong>
              <ExpandableText
                text={prescribedData?.sig}
                maxCharsReceived={110}
              />
            </Typography>
            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <strong>Quantity:</strong>
                <span className="content-text">
                  {[null, ""].includes(prescribedData?.quantity) &&
                  [null, ""].includes(prescribedData?.qtyQualifier)
                    ? "N/A"
                    : `${prescribedData?.quantity ?? "N/A"}  ${
                        prescribedData?.quantity &&
                        prescribedData?.quantityQualifer
                          ? prescriptionForms[prescribedData?.quantityQualifer]
                          : ""
                      }`}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Days Supply:</strong>
                <span className="content-text">
                  {prescribedData?.daysSupply
                    ? prescribedData?.daysSupply
                    : "N/A"}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Refills:</strong>
                <span className="content-text">
                  {prescribedData?.refills || prescribedData?.refills === 0
                    ? prescribedData?.refills
                    : "N/A"}
                </span>
              </Typography>{" "}
            </Box>
            <Typography component={"span"} variant={"body2"}>
              <strong>Substitutions:</strong>
              <span className="content-text">
                {prescribedData?.substitutionName
                  ? prescribedData?.substitutionName
                  : "N/A"}
              </span>
            </Typography>
          </Box>
        </RxChangePrescribedCard>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flex={1}
        >
          <Box
            sx={{
              transform: { xs: "rotate(90deg)", md: "rotate(0deg)" },
            }}
            component="img"
            src={RxAlertsArrow}
            alt="Arrow"
          />
        </Box>
        <RxChangeRequestedCard>
          <Box className="title">
            <img
              src={RxRequestedIcon}
              alt="RX Change Request"
              loading="lazy"
              width="42px"
              height="42px"
            />
            <Typography variant="h6" fontSize={17} color="#0C585B">
              Rx Change requested from Pharmacy
            </Typography>
            <Typography variant="caption" fontSize={14} color="#000000cc">
              For Prescriber Action
            </Typography>
          </Box>
          <Box className="content">
            <Box className="pharmacyNote">
              <HtmlTooltip
                placement="top"
                arrow
                title={
                  requestedData?.pharmacyNote
                    ? requestedData?.pharmacyNote
                    : "Not Available"
                }
              >
                <img src={RxRequestedPharmaNote} alt="Pharmacy Note" />
              </HtmlTooltip>
            </Box>

            <Typography
              component={"span"}
              variant={"body2"}
              alignItems={"center"}
            >
              <strong>Requested Date:</strong>
              {requestedData.rxWrittenDate
                ? requestedData.rxWrittenDate
                : "N/A"}
              {rxChangeAlertsRequestData?.type && (
                <HtmlTooltip
                  placement="top"
                  arrow
                  title={
                    drugTypes[
                      rxChangeAlertsRequestData?.type as keyof typeof drugTypes
                    ]?.description
                  }
                >
                  <Typography
                    bgcolor={"#fccf8b"}
                    component="div"
                    variant="body2"
                    borderRadius={5}
                    paddingX={1}
                    paddingY={0.5}
                    border={"1px solid orange"}
                  >
                    {/* {rxChangeAlertsRequestData?.type} */}
                    {
                      drugTypes[
                        rxChangeAlertsRequestData?.type as keyof typeof drugTypes
                      ]?.title
                    }
                  </Typography>
                </HtmlTooltip>
              )}
            </Typography>

            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <Typography component="span" variant="body2" minWidth="92px">
                  <strong>Drug Name:</strong>
                </Typography>

                <Typography
                  component="span"
                  variant="body2"
                  // flexDirection="column"
                  flexWrap="wrap"
                >
                  <span>
                    {" "}
                    {requestedData?.drugDescription
                      ? requestedData?.drugDescription
                      : "N/A"}
                    {requestedData?.deaClassCode && (
                      <span style={{ color: "#44799C", marginLeft: 4 }}>
                        {requestedData?.deaClassCode}
                      </span>
                    )}
                  </span>

                  {rxChangeAlertsRequestData?.medicationRequested?.length >
                    1 && (
                    <Typography
                      component="span"
                      color="#44799C !important"
                      variant="body2"
                      sx={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        maxWidth: "100%",
                      }}
                      onClick={() => {
                        handleShowMedRequestPopupClick();
                      }}
                    >
                      Alternate Medications
                    </Typography>
                  )}
                </Typography>
              </Typography>{" "}
            </Box>

            <Typography component={"span"} variant={"body2"}>
              <strong>SIG:</strong>
              <ExpandableText
                text={requestedData?.sig}
                maxCharsReceived={140}
              />
            </Typography>
            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <strong>Quantity:</strong>
                <span className="content-text">
                  {[null, ""].includes(requestedData?.quantity) &&
                  [null, ""].includes(requestedData?.quantityQualifer)
                    ? "N/A"
                    : `${requestedData?.quantity ?? "N/A"}  ${
                        requestedData?.quantity &&
                        requestedData?.quantityQualifer
                          ? prescriptionForms[requestedData?.quantityQualifer]
                          : ""
                      }`}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Days Supply:</strong>
                <span className="content-text">
                  {requestedData?.daysSupply
                    ? requestedData?.daysSupply
                    : "N/A"}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Refills:</strong>
                <span className="content-text">
                  {requestedData?.refills || requestedData?.refills === 0
                    ? requestedData?.refills
                    : "N/A"}
                </span>
              </Typography>
            </Box>
            <Typography component={"span"} variant={"body2"}>
              <strong>Substitutions:</strong>
              <span className="content-text">
                {requestedData?.substitutionName
                  ? requestedData?.substitutionName
                  : "N/A"}
              </span>
            </Typography>
          </Box>
        </RxChangeRequestedCard>
      </Box>
    </>
  );
};

export default MedPrescribeRequested;
